import { api } from '@/global/api'
import { TrackingInfoUtms } from '@/modules/simulator/api/types'

export interface UpsertLeadTrackingInfo extends TrackingInfoUtms {
  anonymousId: string
}

export interface UpsertLeadPayload {
  trackingInfo: UpsertLeadTrackingInfo
}

export interface UpsertLeadArgs {
  simulationId: string
  payload: UpsertLeadPayload
}

export interface UpsertLeadResponse {
  id: string
  name?: string
  email?: string
  phoneNumber?: string
}

export const upsertLead = async ({ simulationId, payload }: UpsertLeadArgs) => {
  const { data } = await api.post<UpsertLeadResponse>(
    `/simulation/${simulationId}/lead`,
    payload
  )
  return data
}
